const theme = {};

theme.palette = {
    blackFont: "#333",
    greyFont: "#5f645f",
    mainOrange: "var(--color-primary)",
    mainGreen: "#00953b",
};

theme.fonts = {
    primary:
        '"Gilroy Regular", Helvetica, "Helvetica Neue", Arial, "Lucida Grande", sans-serif',
};

theme.sizes = {
    maxWidth: "1280px",
};

export default theme;
